export default __webpack_public_path__ + "static/media/image-ph-health-briefing-w@2x.3229f703.png";